import {
  JIRA_ASSIGNEE_UNASSIGNED_LABEL,
  JIRA_UNASSIGNED_ASSIGNEE_ID,
  isJiraUnassignedAssignee
} from '../../../../pages/NRSettings/NRIntegrations/NRJiraIntegration/jiraIntegration.constants';

export { JIRA_UNASSIGNED_ASSIGNEE_ID, isJiraUnassignedAssignee };

export const CREATE_JIRA_TICKET_LABELS = {
  DRAWER_TITLE: 'Create ticket',
  JIRA_SPACE: 'Jira space',
  ISSUE_TYPE: 'Issue type',
  SUMMARY: 'Summary',
  DESCRIPTION: 'Description',
  PRIORITY: 'Priority',
  ASSIGNEE: 'Assignee',
  UNASSIGNED: JIRA_ASSIGNEE_UNASSIGNED_LABEL,
  REQUIRED_JIRA_FIELDS: 'Required Jira fields',
  SYNCED_FROM_JIRA: count => `${count} synced from Jira`,
  UNSUPPORTED_FIELDS_COUNT: count => (count === 1 ? '1 field is not supported' : `${count} fields are not supported`),
  SELECT_VALUE: 'Select value',
  ENTER_VALUE: 'Enter value',
  FIELD_REQUIRED: 'This field is required',
  LOADING_ISSUE_FIELDS: 'Loading Jira fields…',
  REFRESH_REQUIRED_FIELDS: 'Refresh fields',
  REFRESH_REQUIRED_FIELDS_ARIA: 'Refresh required Jira fields from Jira',
  UNSUPPORTED_REQUIRED_FIELDS_TITLE: 'Some required Jira fields are not supported',
  UNSUPPORTED_REQUIRED_FIELDS_BODY:
    'This Jira space requires fields we cannot collect yet. Create will fail until they are supported or made optional in Jira:',
  ATTACHMENTS: 'Attachments',
  SBOM: 'SBOM',
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
  CANCEL: 'Cancel',
  CREATE: 'Create',
  VULNERABILITY: 'Vulnerability',
  SEVERITY: 'Severity',
  EPSS: 'EPSS',
  COMPONENT: 'Component',
  CREATE_SUCCESS: 'Jira ticket created successfully.',
  CREATE_ERROR: 'Failed to create Jira ticket.'
};

export const JIRA_PRIORITY_FIELD_KEY = 'priority';
export const JIRA_ASSIGNEE_FIELD_KEY = 'assignee';

/** Field keys already collected by the static create-ticket form. */
export const STATIC_JIRA_FIELD_KEYS = new Set([
  'summary',
  'description',
  'issuetype',
  'project',
  'parent',
  'reporter',
  JIRA_PRIORITY_FIELD_KEY,
  JIRA_ASSIGNEE_FIELD_KEY
]);

/** Schema types / keys that should never be rendered in the dynamic form. */
export const IGNORED_JIRA_SCHEMA_TYPES = new Set(['any', 'issuelink', 'attachment']);
export const IGNORED_JIRA_FIELD_KEYS = new Set(['customfield_10000']);

/** Option-backed schema types that need allowedValues or a dedicated RPC. */
export const JIRA_OPTION_SCHEMA_TYPES_NEEDING_RPC_OR_ALLOWED_VALUES = new Set([
  'user',
  'group',
  'version',
  'component',
  'option',
  'priority',
  'securitylevel',
  'sprint',
  'team',
  'issuelink',
  'project',
  'issuetype',
  'status',
  'resolution'
]);

export const SINGLE_SELECT_SCHEMA_TYPES = new Set([
  'issuetype',
  'project',
  'option',
  'priority',
  'status',
  'resolution',
  'component',
  'version',
  'securitylevel',
  'sprint',
  'team'
]);

/** Option lists that come from dedicated Turbine RPCs (not field.allowedValues). */
export const JIRA_RPC_OPTION_SOURCE = {
  VERSIONS: 'versions',
  COMPONENTS: 'components',
  LABELS: 'labels',
  USERS: 'users',
  SPRINTS: 'sprints',
  TEAMS: 'teams'
};

/** Standard Jira priorities — kept as fallback reference; prefer allowedValues from the space schema. */
export const DEFAULT_JIRA_PRIORITY_OPTIONS = ['Highest', 'High', 'Medium', 'Low', 'Lowest'];
